(function () {
  'use strict';
  var DELAY_MS = 10000;
  var engaged = false;
  function engage() {
    if (engaged) return;
    engaged = true;
    document.documentElement.classList.add('ez-p0-engage');
  }
  // P0-5: unlock Omnisend soft-gate after 10s (theme promo-popup uses its own timeout)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(engage, DELAY_MS); });
  } else {
    setTimeout(engage, DELAY_MS);
  }

  function currentProductPath() {
    var m = location.pathname.match(/\/products\/[^\/?#]+/);
    return m ? m[0] : null;
  }

  var SANTA_PATH = '/products/eggzu-santa-kids-bean-bag-chair';
  var SANTA_BAD = /eggplant|adult\s+(?:sofa|universal|bean)|monster(?:\s+air|\s+bed|\s+play)?|kangaroo|penguin|snowman|reindeer|unicorn|pineapple|strawberry|\bbigger size\b|\b48\s*in(?:ch(?:es)?)?\b|\b36\s*in(?:ch(?:es)?)?\b/i;

  function reviewBody(rev) {
    var body = rev.querySelector('.jdgm-rev__body');
    var title = rev.querySelector('.jdgm-rev__title');
    return ((title && title.textContent) || '') + ' ' + ((body && body.textContent) || '');
  }

  function isReviewVisible(rev) {
    if (!rev || rev.classList.contains('ez-p0-hidden-review')) return false;
    if (rev.style && rev.style.display === 'none') return false;
    var cs = window.getComputedStyle ? getComputedStyle(rev) : null;
    if (cs && (cs.display === 'none' || cs.visibility === 'hidden')) return false;
    return true;
  }

  function syncReviewSummary(root) {
    var scope = root || document;
    var widgets = scope.querySelectorAll('.jdgm-rev-widg, .jdgm-widget');
    if (!widgets.length && scope.classList && (scope.classList.contains('jdgm-rev-widg') || scope.classList.contains('jdgm-widget'))) {
      widgets = [scope];
    }
    widgets.forEach(function (widg) {
      var revs = widg.querySelectorAll('.jdgm-rev');
      if (!revs.length) return;
      var visible = 0;
      revs.forEach(function (rev) { if (isReviewVisible(rev)) visible++; });
      // Update "Based on N reviews" style summary text nodes
      var summaryEls = widg.querySelectorAll('.jdgm-rev-widg__summary-text, .jdgm-histogram__average, .jdgm-rev-widg__header');
      summaryEls.forEach(function (el) {
        if (!el || !el.textContent) return;
        var t = el.textContent;
        if (/based on\s+\d+\s+reviews?/i.test(t)) {
          el.textContent = t.replace(/based on\s+\d+\s+reviews?/i, 'Based on ' + visible + (visible === 1 ? ' review' : ' reviews'));
        }
      });
      // Judge.me sometimes puts count in data attributes / average row
      var countEls = widg.querySelectorAll('[data-number-of-reviews], .jdgm-rev-widg__summary-average, .jdgm-rev-widg__summary');
      countEls.forEach(function (el) {
        if (el.hasAttribute && el.hasAttribute('data-number-of-reviews')) {
          el.setAttribute('data-number-of-reviews', String(visible));
        }
        if (el.textContent && /based on\s+\d+\s+reviews?/i.test(el.textContent)) {
          el.textContent = el.textContent.replace(/based on\s+\d+\s+reviews?/i, 'Based on ' + visible + (visible === 1 ? ' review' : ' reviews'));
        }
      });
      // Broader text walk within widget for "Based on N reviews"
      try {
        var walker = document.createTreeWalker(widg, NodeFilter.SHOW_TEXT, null);
        var node;
        while ((node = walker.nextNode())) {
          if (node.nodeValue && /based on\s+\d+\s+reviews?/i.test(node.nodeValue)) {
            node.nodeValue = node.nodeValue.replace(/based on\s+\d+\s+reviews?/i, 'Based on ' + visible + (visible === 1 ? ' review' : ' reviews'));
          }
        }
      } catch (e) {}
    });
  }

  function filterReviews(root) {
    var path = currentProductPath();
    var scope = root || document;
    var revs = scope.querySelectorAll('.jdgm-rev');
    var hiddenIds = [];
    revs.forEach(function (rev) {
      var hide = false;
      var reason = '';
      var prodUrl = rev.getAttribute('data-product-url') || '';
      if (path && prodUrl) {
        try {
          var u = prodUrl.indexOf('http') === 0 ? new URL(prodUrl).pathname : prodUrl;
          if (u && u.indexOf(path) === -1) {
            hide = true;
            reason = 'cross-product';
          }
        } catch (e) {}
      }
      if (!hide && path === SANTA_PATH) {
        var text = reviewBody(rev);
        if (SANTA_BAD.test(text)) {
          hide = true;
          reason = 'santa-keyword';
        }
      }
      if (hide) {
        rev.classList.add('ez-p0-hidden-review');
        rev.style.display = 'none';
        var id = rev.getAttribute('data-review-id');
        if (id) hiddenIds.push({ id: id, reason: reason });
      }
    });
    if (hiddenIds.length && !window.__ezP0HiddenLogged) {
      window.__ezP0HiddenLogged = true;
      try { console.info('[eggzu-p0] hidden reviews', hiddenIds); } catch (e) {}
      window.__ezP0HiddenReviews = hiddenIds;
    }
    // P1: sync "Based on N reviews" to visible count (Santa + filtered PDPs)
    syncReviewSummary(document);
  }

  function bootFilters() {
    filterReviews(document);
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType === 1 && (n.classList.contains('jdgm-rev') || (n.querySelector && n.querySelector('.jdgm-rev')))) {
            filterReviews(n.classList.contains('jdgm-rev') ? n.parentNode || document : n);
          }
          if (n.nodeType === 1 && (n.classList.contains('jdgm-rev-widg') || (n.querySelector && n.querySelector('.jdgm-rev-widg__summary-text')))) {
            syncReviewSummary(n);
          }
        }
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootFilters);
  } else {
    bootFilters();
  }
})();
